export const orReducer = (
    aggregation: boolean | undefined,
    value: boolean | undefined
): boolean | undefined => {
    return aggregation || value;
};
